import React, { useEffect, useRef, useState } from 'react'
import { Transcript } from 'interfaces/db/transcript'
import { SentenceHeading } from './SentenceHeading'
import { condenseTranscript } from 'util/transcript/condense-transcript'
import { toast } from 'react-hot-toast'

export const EmbeddedTranscriptViewer = ({
  transcript,
  isPlaying,
  play,
  pause,
  progress,
  setAudioTime,
}: {
  transcript: Transcript
  isPlaying: boolean
  play: () => void
  pause: () => void
  progress: number
  setAudioTime: (time: number) => void
}) => {
  const transcriptRef = useRef<HTMLDivElement>(null)
  const containerRef = useRef<HTMLDivElement>(null)

  const condensedTranscript = condenseTranscript(transcript)

  return (
    <div ref={containerRef}>
      <div ref={transcriptRef}>
        {condensedTranscript.sentences.map((group, groupIndex) => (
          <div
            key={groupIndex}
            className="relative my-1 mt-2 flex flex-col justify-between gap-2 border-l-2 border-blue-300 px-2"
          >
            <SentenceHeading
              sentence={group}
              editable={false}
              handleEditSpeaker={() => {}}
              isPlaying={isPlaying}
              setAudioTime={(time) => {
                setAudioTime(time)
                play()
              }}
              progress={progress}
              pause={pause}
              play={play}
            />
            <div
              className={`prose-base hover:bg-toasty-blue-50 prose-lead:prose`}
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                toast.error('Editing is not available in preview mode.')
              }}
            >
              {group.originalSentences.map((sentence, sentenceIndex) => (
                <div key={sentenceIndex} className="pb-1">
                  {sentence.words.map((word, wordIndex) => (
                    <span
                      key={wordIndex}
                      data-word-start={word.start}
                      data-word-end={word.end}
                      data-word-index={`${groupIndex}-${sentenceIndex}-${wordIndex}`}
                    >
                      {word.text}{' '}
                    </span>
                  ))}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
